import { HeroWrapperProps } from 'sly/agentsPage/components/AgentsHeader/HeroWrapper/HeroWrapper.types';

export default function HeroWrapper({ children, heroRef }: HeroWrapperProps) {
  return (
    <div
      className='hero-wrapper'
      ref={heroRef}
      data-tp-id='gen-div-25efead0-c750-414f-81dc-711478192d2c'
    >
      {children}
    </div>
  );
}
